/**
 * tdesign v1.6.6
 * (c) 2023 tdesign
 * @license MIT
 */

import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { reactive, onMounted } from '@vue/composition-api';
import { usePrefixClass } from '../../hooks/useConfig.js';
import useLazyLoad from '../../hooks/useLazyLoad.js';
import useItemEvents from './useItemEvents.js';
import useRenderIcon from './useRenderIcon.js';
import useRenderLabel from './useRenderLabel.js';
import useRenderLine from './useRenderLine.js';
import useRenderOperations from './useRenderOperations.js';
import useDraggable from './useDraggable.js';
import '../../config-provider/useConfig.js';
import '../../config-provider/context.js';
import 'lodash/merge';
import 'lodash/mergeWith';
import '../../_common/js/global-config/default-config.js';
import '../../_common/js/global-config/locale/zh_CN.js';
import '@babel/runtime/helpers/typeof';
import '../../_chunks/dep-fdafdce0.js';
import 'dayjs';
import '../../_chunks/dep-9849f16c.js';
import '../../config-provider/type.js';
import '../../_common/js/utils/observe.js';
import 'tdesign-icons-vue';
import '../../hooks/useGlobalIcon.js';
import '../../loading/index.js';
import '../../loading/directive.js';
import 'lodash/isObject';
import 'lodash/mapKeys';
import 'lodash/isEqual';
import '../../loading/plugin.js';
import 'vue';
import '../../loading/loading.js';
import '../../loading/icon/gradient.js';
import '../../_common/js/loading/circle-adapter.js';
import '../../_common/js/utils/set-style.js';
import '../../_common/js/utils/helper.js';
import '@babel/runtime/helpers/toConsumableArray';
import '@babel/runtime/helpers/objectWithoutProperties';
import '@babel/runtime/helpers/slicedToArray';
import 'lodash/isString';
import 'lodash/isNull';
import 'lodash/isUndefined';
import 'lodash/isNumber';
import 'lodash/isArray';
import '../../config-provider/config-receiver.js';
import '../../utils/mixins.js';
import '../../utils/dom.js';
import 'raf';
import '../../utils/easing.js';
import '../../utils/render-tnode.js';
import 'lodash/camelCase';
import 'lodash/kebabCase';
import '../../utils/transfer-dom.js';
import '../../loading/props.js';
import '../../config.js';
import '../../utils/withInstall.js';
import 'lodash/capitalize';
import './style/css.js';
import '../../loading/type.js';
import '../util.js';
import '../../_chunks/dep-1461d230.js';
import 'lodash/isBoolean';
import '../../checkbox/index.js';
import '../../checkbox/group.js';
import 'lodash/intersection';
import '../../checkbox/checkbox.js';
import '../../checkbox/props.js';
import '../../hooks/index.js';
import '../../hooks/slots.js';
import '../../hooks/useCommonClassName.js';
import '../../hooks/useDefaultValue.js';
import '../../hooks/useDestroyOnClose.js';
import '../../hooks/useElementLazyRender.js';
import '../../hooks/useFormDisabled.js';
import '../../hooks/useResizeObserver.js';
import '../../hooks/useVirtualScrollNew.js';
import '../../hooks/useVModel.js';
import '../../hooks/useImagePreviewUrl.js';
import '../../_common/js/upload/utils.js';
import '../../_common/js/log/log.js';
import '../../checkbox/constants.js';
import '../../checkbox/store.js';
import '@babel/runtime/helpers/classCallCheck';
import '@babel/runtime/helpers/createClass';
import '../../checkbox/hooks/useKeyboardEvent.js';
import '../../checkbox/checkbox-group-props.js';
import '../../checkbox/type.js';
import 'lodash/throttle';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function useTreeItem(props, context, treeItemRef) {
  var node = props.node,
    treeScope = props.treeScope;
  var virtualConfig = treeScope.virtualConfig,
    treeContentRef = treeScope.treeContentRef;
  var scrollProps = treeScope === null || treeScope === void 0 ? void 0 : treeScope.scrollProps;
  var classPrefix = usePrefixClass().value;
  var componentName = usePrefixClass("tree").value;
  var _useItemEvents = useItemEvents(props, context),
    handleClick = _useItemEvents.handleClick;
  var _useRenderIcon = useRenderIcon(props),
    renderIcon = _useRenderIcon.renderIcon;
  var _useRenderLabel = useRenderLabel(props, context),
    renderLabel = _useRenderLabel.renderLabel;
  var _useRenderLine = useRenderLine(props),
    renderLine = _useRenderLine.renderLine;
  var _useRenderOperations = useRenderOperations(props),
    renderOperations = _useRenderOperations.renderOperations;
  var _useDraggable = useDraggable(props, treeItemRef),
    dragStates = _useDraggable.dragStates,
    handleDragStart = _useDraggable.handleDragStart,
    handleDragEnd = _useDraggable.handleDragEnd,
    handleDragOver = _useDraggable.handleDragOver,
    handleDragLeave = _useDraggable.handleDragLeave,
    handleDrop = _useDraggable.handleDrop;
  var _useLazyLoad = useLazyLoad(treeContentRef, treeItemRef, reactive(_objectSpread({}, scrollProps === null || scrollProps === void 0 ? void 0 : scrollProps.value))),
    hasLazyLoadHolder = _useLazyLoad.hasLazyLoadHolder,
    tRowHeight = _useLazyLoad.tRowHeight;
  onMounted(function () {
    var isVirtual = virtualConfig === null || virtualConfig === void 0 ? void 0 : virtualConfig.isVirtualScroll.value;
    if (isVirtual) {
      virtualConfig.handleRowMounted({
        ref: treeItemRef,
        data: node
      });
    }
  });
  var getItemStyles = function getItemStyles() {
    var level = node.level;
    var levelStyle = "--level: ".concat(level, ";");
    var strStyle = "".concat(levelStyle);
    return strStyle;
  };
  var getItemClassList = function getItemClassList() {
    var _list$push, _list$push3;
    var isDragOver = dragStates.isDragOver,
      isDragging = dragStates.isDragging,
      dropPosition = dragStates.dropPosition;
    var list = [];
    list.push("".concat(componentName, "__item"));
    list.push((_list$push = {}, _defineProperty(_list$push, "".concat(componentName, "__item--open"), node.expanded), _defineProperty(_list$push, "".concat(classPrefix, "-is-active"), node.isActivable() ? node.actived : false), _defineProperty(_list$push, "".concat(classPrefix, "-is-disabled"), node.isDisabled()), _list$push));
    list.push(_defineProperty({}, "".concat(componentName, "__item--draggable"), node.isDraggable()));
    if (node.visible) {
      list.push("".concat(componentName, "__item--visible"));
    } else {
      list.push("".concat(componentName, "__item--hidden"));
    }
    if (node.vmIsLocked) {
      list.push("".concat(componentName, "__item--locked"));
    }
    if (node.vmIsRest) {
      list.push("".concat(componentName, "__item--matched"));
    }
    list.push((_list$push3 = {}, _defineProperty(_list$push3, "".concat(componentName, "__item--dragging"), isDragging), _defineProperty(_list$push3, "".concat(componentName, "__item--tip-top"), isDragOver && dropPosition < 0), _defineProperty(_list$push3, "".concat(componentName, "__item--tip-bottom"), isDragOver && dropPosition > 0), _defineProperty(_list$push3, "".concat(componentName, "__item--tip-highlight"), !isDragging && isDragOver && dropPosition === 0), _list$push3));
    return list;
  };
  var renderItem = function renderItem(h) {
    var itemNodes = [];
    var iconNode = renderIcon(h);
    var lineNode = renderLine(h);
    if (lineNode) {
      itemNodes.push(lineNode);
    }
    if (iconNode) {
      itemNodes.push(iconNode);
    }
    var labelNode = renderLabel(h);
    if (labelNode) {
      itemNodes.push(labelNode);
    }
    var opNode = renderOperations(h);
    if (opNode) {
      itemNodes.push(opNode);
    }
    return itemNodes;
  };
  var renderItemNode = function renderItemNode(h) {
    var level = node.level,
      value = node.value;
    var styles = getItemStyles();
    var classList = getItemClassList();
    var itemNode = h("div", {
      "ref": "treeItemRef",
      "class": classList,
      "attrs": {
        "data-value": value,
        "data-level": level,
        "draggable": node.isDraggable()
      },
      "style": styles,
      "on": {
        "click": function click(evt) {
          return handleClick(evt);
        },
        "dragstart": function dragstart(evt) {
          return handleDragStart(evt);
        },
        "dragend": function dragend(evt) {
          return handleDragEnd(evt);
        },
        "dragover": function dragover(evt) {
          return handleDragOver(evt);
        },
        "dragleave": function dragleave(evt) {
          return handleDragLeave(evt);
        },
        "drop": function drop(evt) {
          return handleDrop(evt);
        }
      }
    }, [hasLazyLoadHolder.value ? [h("div")] : renderItem(h)]);
    return itemNode;
  };
  return {
    hasLazyLoadHolder: hasLazyLoadHolder,
    tRowHeight: tRowHeight,
    renderItemNode: renderItemNode
  };
}

export { useTreeItem as default };
//# sourceMappingURL=useTreeItem.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/tdesign-vue/es/tree/hooks/useTreeItem.js
// module id = null
// module chunks = 